import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class F1120SchcLine22Service {

  constructor(private http: HttpClient) {}

  private readonly GET_ACTION_CODE  = 'gro8r9';
  private readonly SAVE_ACTION_CODE = 'axl5mk';
  private readonly FORM_NAME        = 'F1120';
  private readonly SCHD_NAME        = 'C';
  private readonly PART_NUMBER      = null;
  private readonly SECTION_NAME     = null;

  getModalData(
    baseUrl: string,
    rowData: any,
    globalService: any = {},
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=${this.GET_ACTION_CODE}`;

    // Merge globalParams → filterParams → explicit row-level params (later wins).
    // Middleware generates: checkLockedbj, screen_type, is_locked, issue_id,
    // issue_short_desc, issue_id_for_tx_save, scenarioCode, is_issue_key_enabled.
    const gp = globalService?.globalParams || {};
    const merged: Record<string, any> = { ...gp, ...filterParams };
    delete merged['checkLockedbj'];

    const params: Record<string, any> = {
      ...merged,
      combination_key: rowData.COMBINATION_KEY || '',
      form_name:       this.FORM_NAME,
      schedule_name:   this.SCHD_NAME,
      part_number:     this.PART_NUMBER,
      section_name:    this.SECTION_NAME
    };

    // Strip nulls so HttpClient doesn't encode them as the string "null"
    Object.keys(params).forEach(key => {
      if (params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });

    return this.http.get<any>(url, { params, withCredentials: true });
  }

  saveOverride(
    baseUrl: string,
    clobData: any[] | string,
    clobSetting: any[] | string,
    processName: string,
    ssoId: string,
    globalService: any = {},
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=${this.SAVE_ACTION_CODE}`;

    const gp = globalService?.globalParams || {};

    const params: any = {
      sso_id:               ssoId                                                                                           || null,
      tax_year:             filterParams.tax_year          || gp.tax_year                                                  || null,
      scenario:             filterParams.scenario          || gp.scenario                                                  || null,
      jcd_key:              filterParams.jcd_key           || gp.jcd_key                                                   || null,
      scenarioCode:         filterParams.scenarioCode      || filterParams.scenario_code || gp.scenarioCode                || 'RAF',
      is_issue_key_enabled: filterParams.is_issue_key_enabled                            || gp.is_issue_key_enabled        || 'N',
      form_name:            this.FORM_NAME,
      schd_name:            this.SCHD_NAME,
      clob_setting:         typeof clobSetting === 'string' ? clobSetting : JSON.stringify(clobSetting),
      clob_data:            typeof clobData    === 'string' ? clobData    : JSON.stringify(clobData),
      process_name:         processName                                                                                     || null
    };

    const formData = new FormData();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        formData.append(key, params[key].toString());
      }
    });

    return this.http.post<any>(url, formData, { withCredentials: true });
  }
}
